import actionTypes from '../common/actionTypes';

interface State {
	customersCount: PeriodCountDto;
	users: UserDetails[];
	policiesCount: PeriodCountDto;
	unmailedPolicies: CustomerPolicy[];
	unmailedPoliciesCount: UnmailedPolicyCountDto;
	failedPaymentsCount: number | undefined;
	failedPayments: PaymentHistory[];
	expiringPoliciesCount: number | undefined;
	expiringPolicies: CustomerPolicy[];
	missingBeneficiaryFormsCount: number | undefined;
	bouncedEmailsCount: number | undefined;
	bouncedEmails: BouncedEmail[];
	financials: FinancialExportDto[];
	referrals: FinancialExportDto[];
}
const initialState: State = {
	customersCount: {},
	users: [],
	policiesCount: {},
	unmailedPolicies: [],
	unmailedPoliciesCount: {},
	failedPaymentsCount: undefined,
	failedPayments: [],
	expiringPoliciesCount: undefined,
	expiringPolicies: [],
	missingBeneficiaryFormsCount: undefined,
	bouncedEmailsCount: undefined,
	bouncedEmails: [],
	financials: [],
	referrals: []
};
export default function reportReducer(state: State = initialState, action: any) {
	switch (action.type) {
		case actionTypes.FETCH_CUSTOMERS_COUNT:
			return { ...state, customersCount: action.customersCount };
		case actionTypes.FETCH_USER_ACTIVITIES:
			return { ...state, users: action.users };
		case actionTypes.FETCH_POLICIES_COUNT:
			return { ...state, policiesCount: action.policiesCount };
		case actionTypes.FETCH_UNMAILED_POLICIES_COUNT:
			return { ...state, unmailedPoliciesCount: action.unmailedPoliciesCount };
		case actionTypes.FETCH_UNMAILED_POLICIES:
			return { ...state, unmailedPolicies: action.unmailedPolicies };
		case actionTypes.FETCH_FAILED_PAYMENTS_COUNT:
			return { ...state, failedPaymentsCount: action.failedPaymentsCount };
		case actionTypes.FETCH_FAILED_PAYMENTS:
			return { ...state, failedPayments: action.failedPayments };
		case actionTypes.FETCH_EXPIRING_POLICIES_COUNT:
			return { ...state, expiringPoliciesCount: action.expiringPoliciesCount };
		case actionTypes.FETCH_EXPIRING_POLICIES:
			return { ...state, expiringPolicies: action.expiringPolicies };
		case actionTypes.FETCH_MISSING_BENEFICIARY_FORMS_COUNT:
			return { ...state, missingBeneficiaryFormsCount: action.missingBeneficiaryFormsCount };
		case actionTypes.FETCH_BOUNCED_EMAILS_COUNT:
			return { ...state, bouncedEmailsCount: action.bouncedEmailsCount };
		case actionTypes.FETCH_BOUNCED_EMAILS:
			return { ...state, bouncedEmails: action.bouncedEmails };
		case actionTypes.RESOLVE_BOUNCED_EMAIL:
			let filteredEmails = state.bouncedEmails.filter(e => e.id !== action.bouncedEmail.id);
			return {
				...state,
				bouncedEmails: [...filteredEmails, action.bouncedEmail]
			};
		case actionTypes.FETCH_FINANCIAL_REPORT:
			return { ...state, financials: action.financials };
		case actionTypes.FETCH_REFERRALS:
			return { ...state, referrals: action.referrals };
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/report/reportReducer.ts